import React from 'react'

export const DarkCard:React.FunctionComponent<{children: React.ReactNode, className?: string}> = ({children, className}) => {
  return (
    <div className={`dark-card p-3 ${className || ""}`}>
      {children}
    </div>
  )
}
